import * as React from "react";
import BackButton from "../../core/BackButton/BackButton";
import Spinner from "../../core/Spinner/Spinner";
import { ITranslationProps, translateComponent } from "../../helpers/translation";

interface IChangeCustomerProps extends ITranslationProps {
    clientName: string;
    clientHeaderIDValid: boolean;
    onSubmit: (password: string) => Promise<boolean>;
}

interface IChangeCustomerState {
    password: string;
    validated: boolean;
    requestFailed: boolean;
    processing: boolean;
}

class ChangeCustomer extends React.Component<IChangeCustomerProps, IChangeCustomerState> {
    private formElement: HTMLFormElement | null;

    constructor(props: IChangeCustomerProps) {
        super(props);

        this.state = {
            password: "",
            validated: false,
            requestFailed: false,
            processing: false,
        };

        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onChangeCustomerClick = this.onChangeCustomerClick.bind(this);
        this.inputKeypress = this.inputKeypress.bind(this);
    }

    public render() {
        if (this.props.clientHeaderIDValid) {
            return (
                <div>
                    {this.state.processing && <Spinner />}
                    <BackButton />
                    <h2>{this.props.t("ChangeCustomer.Title")}</h2>
                    <div className="mb-3">{this.props.t("ChangeCustomer.Instructions")} <b>{this.props.clientName}</b></div>
                    <form ref={ref => this.formElement = ref} className={this.state.validated ? "was-validated" : "needs-validation"} noValidate={true}>
                        <div className="form-group">
                            <label>{this.props.t("ChangeCustomer.Password")}</label>
                            <input
                                type="password"
                                className="form-control"
                                placeholder={this.props.t("ChangeCustomer.Password")}
                                value={this.state.password}
                                onChange={this.onPasswordChange}
                                onKeyPress={this.inputKeypress}
                                required={true}
                                autoFocus={true} />

                            <div className="invalid-feedback">
                                {this.props.t("ChangeCustomer.PasswordValidationMessage")}
                            </div>
                        </div>

                        <button type="button" className="btn btn-primary" onClick={this.onChangeCustomerClick}>{this.props.t("ChangeCustomer.ChangeCustomerButton")}</button>

                        {this.state.requestFailed && <div className="mt-3 alert alert-danger">{this.props.t("ChangeCustomer.FailureMessage")}</div>}
                    </form>
                </div>
            );
        } else {
            return (
                <div>
                    <BackButton />
                    <h2>{this.props.t("ChangeCustomer.Title")}</h2>
                    <div className="mt-3 alert alert-danger">{this.props.t("ChangeCustomer.InvalidClientHeaderID")}</div>
                </div>
            );
        }
    }

    private onPasswordChange(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({ password: event.target.value });
    }

    private inputKeypress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (event.key === "Enter") {
            event.preventDefault();
            this.onChangeCustomerClick();
        }
    }

    private async onChangeCustomerClick(): Promise<void> {
        this.setState({ validated: true });

        if (this.formElement && this.formElement.checkValidity()) {
            this.setState({ processing: true }, async () => {
                const result = await this.props.onSubmit(this.state.password);
                this.setState({ requestFailed: !result, processing: false, password: "", validated: false });
            });
        }
    }

}

export default translateComponent(ChangeCustomer);



// WEBPACK FOOTER //
// ./src/components/ChangeCustomer/ChangeCustomer.tsx